import React from "react";
import styles from "./styles.module.scss";
import { GroupSelectProps } from "./index.types";
import no_team_png from "app/images/null-training-space.png";
import UserAvatar from "app/components/UserAvatar";
import { cls } from "app/utils";
import useTeamSelectModal from "./indexModel";
import TeamModel from "app/models/TeamModel";
import NoResults from "../NoResults";
import ApplyTemplateListsModal from "../ApplyTemplateListsModal";
import { useTranslation } from "react-i18next";
import { Loading } from "app/components/Wrappers";

const GroupSelectModal = ({
  onClose,
  isOpen,
  templateId,
}: GroupSelectProps) => {
  const { t } = useTranslation();
  const {
    teamSelectHandler,
    cancelHandler,
    applyHandler,
    onSearchTeam,
    team,
    searchTerm,
    results,
    selectedTeamsId,
  } = useTeamSelectModal({ onClose, templateId });

  if (!isOpen) {
    return null;
  }

  // data == null only means "still loading" while the fetch hasn't failed;
  // after @team.fetch.error, data stays null with pending false.
  const isLoading = team.pending || (team.data == null && !team.error);

  return (
    <ApplyTemplateListsModal
      applyHandler={applyHandler}
      cancelHandler={cancelHandler}
      hasNoResult={
        searchTerm?.length === 0 &&
        !team.pending &&
        team.data != null &&
        team.data.length === 0
      }
      noResultImage={no_team_png}
      noResultTitle={t("No Groups")}
      noResultSubText={t("You don't have created a group yet")}
      isOpen={isOpen}
      onClose={onClose}
      searchPlaceholder={t("Search Group...")}
      onSearchChange={onSearchTeam}
      modalSubTitle={t(
        "You can apply this Template to the Group and posts will be added to the General Channel in the set interval and order",
      )}
    >
      <div className={styles.team_list_container}>
        {isLoading && <Loading isLoading={isLoading} loadType="spinner" />}
        {!isLoading && searchTerm.length > 0 && results.length === 0 && (
          <NoResults
            text={t('No results found for "{{keyword}}"', {
              keyword: searchTerm,
            })}
          />
        )}
        {!isLoading &&
          results &&
          results.map((team: TeamModel) => {
            return (
              <div
                key={team.id}
                className={cls(styles.team_container, {
                  [styles.disabled]: !team.planPermissions.includes("post"),
                })}
                onClick={() =>
                  team.planPermissions.includes("post")
                    ? teamSelectHandler(team.id as string, team)
                    : null
                }
              >
                <div className={styles.avatar}>
                  <UserAvatar
                    sizeWidth={44}
                    sizeHeight={44}
                    className="avatar"
                    userName={team.name}
                    srcName={team.logo}
                    altName={team.name}
                  />
                </div>
                <div className={styles.team}>
                  <div className={cls(styles.team_title, styles.elipsis)}>
                    {team.name}
                  </div>
                  <div className={cls(styles.team_subtitle, styles.elipsis)}>
                    {team.sport}
                  </div>
                </div>
                <span className={styles.checkbox}>
                  {selectedTeamsId.includes(team.id) ? (
                    <i className={cls("fas fa-check-circle", styles.checked)} />
                  ) : (
                    <i className={cls("far fa-circle", styles.unchecked)} />
                  )}
                </span>
              </div>
            );
          })}
      </div>
    </ApplyTemplateListsModal>
  );
};

export default GroupSelectModal;
